import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import ToastPortal from "./ToastPortal";
import { registerToastFunction } from "../Services/toastService";
const ToastContext = createContext();

export const useToasts = () => {
  return useContext(ToastContext);
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, code, level, autoDismiss = true, color = null) => {
    setToasts((prevToasts) => {
      if (prevToasts.some((toast) => toast.code === code)) {
        return prevToasts;
      }
      const id = Math.random().toString(36).substr(2, 9);
      return [...prevToasts, { id, message, code, level, autoDismiss, color }];
    });
  }, []);

  const clearToasts = useCallback(() => {
    setToasts([]);
  });

  const removeToast = useCallback((id) => {
    setToasts((prevToasts) => prevToasts.filter((t) => t.id !== id));
  }, []);

  useEffect(() => {
    registerToastFunction(addToast);
  }, [addToast]);

  return (
    <ToastContext.Provider value={{ addToast, removeToast, clearToasts }}>
      {children}
      <ToastPortal toasts={toasts} removeToast={removeToast} clearToasts={clearToasts} />
    </ToastContext.Provider>
  );
};
